/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';

/**
 * 
 * @export
 * @interface UserModifiedResponse
 */
export interface UserModifiedResponse {
    /**
     * Whether the operation was successful
     * @type {boolean}
     * @memberof UserModifiedResponse
     */
    success: boolean;
    /**
     * Informational messages about the operation
     * @type {Array<string>}
     * @memberof UserModifiedResponse
     */
    messages: Array<string>;
    /**
     * The updated user
     * @type {User}
     * @memberof UserModifiedResponse
     */
    entity: User;
}

/**
 * Check if a given object implements the UserModifiedResponse interface.
 */
export function instanceOfUserModifiedResponse(value: object): value is UserModifiedResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('messages' in value) || value['messages'] === undefined) return false;
    if (!('entity' in value) || value['entity'] === undefined) return false;
    return true;
}

export function UserModifiedResponseFromJSON(json: any): UserModifiedResponse {
    return UserModifiedResponseFromJSONTyped(json, false);
}

export function UserModifiedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserModifiedResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'messages': json['messages'],
        'entity': UserFromJSON(json['entity']),
    };
}

export function UserModifiedResponseToJSON(json: any): UserModifiedResponse {
    return UserModifiedResponseToJSONTyped(json, false);
}

export function UserModifiedResponseToJSONTyped(value?: UserModifiedResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'messages': value['messages'],
        'entity': UserToJSON(value['entity']),
    };
}

